import SectionHeader from "../SectionHeader/SectionHeader";
import styles from "./Services.module.css";
import { services } from "./Services.controller";

const Services = () => {
  return (
    <section className={styles.section} id="services">
      <SectionHeader
        eyebrow="Services"
        title="Everything you need to ship and scale."
        description="From the first spark to version ten, we design and build polished experiences that stay fast, secure, and easy to evolve."
      />

      <div className={styles.serviceGrid}>
        {services.map((service) => (
          <div key={service.title} className={styles.serviceCard}>
            <div className={styles.serviceIcon}>*</div>
            <div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
